import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

export const PageRefreshModal = () => {
    const location = useLocation();
    const [showUpdate, setShowUpdate] = useState(false);

    useEffect(() => {
        const trackedRoutes = ["/order", "/checkout", "/my-account"];
        const isTrackedRoute = trackedRoutes.some(route => location.pathname.startsWith(route));
        const checkRefresh = async () => {
            try {
                if (isTrackedRoute) {
                    const res = await fetch("/version.json", { cache: "no-store" });
                    const data = await res.json();

                    const storedVersion = localStorage.getItem("lastRefreshVersion");

                    if (data.breaking && data.forceRefreshVersion !== storedVersion) {
                        setShowUpdate(true);
                    }
                }
            } catch (e) {
                console.error("Refresh check failed:", e);
            }
        };

        checkRefresh();
    }, [location]);

    const handleRefresh = () => {
        fetch("/version.json")
            .then(res => res.json())
            .then(data => {
                localStorage.setItem("lastRefreshVersion", data.forceRefreshVersion);
                window.location.reload();
            });
    };

    return (
        <Modal show={showUpdate} centered backdrop="static">
            <Modal.Header>
                <Modal.Title>New Update Available</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                A new version of this application is available. Please refresh the page to get the latest updates.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleRefresh}>Refresh</Button>
            </Modal.Footer>
        </Modal>
    );
};